module.exports = __webpack_public_path__ + "static/22-d9f1cc961d1c9565195ca4a3e1971537.jpg";